import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from "react-router-dom";
import { GetScope } from "../../features/authentication/hooks/useToken"


// Home Component

const Home = () => {
  const navigate = useNavigate();
  const [checkedDeepLink, setCheckedDeepLink] = useState(false);

  useEffect(() => {
    const deepLinkStr = sessionStorage.getItem("deepLink");

    if (deepLinkStr) {
      const deepLink = JSON.parse(deepLinkStr);
      const apiToken = JSON.parse(localStorage.getItem("apiToken"));
      if (
        deepLink?.role === apiToken?.userRole &&
        deepLink?.associateId === apiToken?.associateId
      ) {
        // sessionStorage.removeItem("deepLink");
        if (apiToken.userRole == "ClientUser") {
          sessionStorage.setItem("usedDeepLink", "true");
        }
        // navigate(deepLink.currentPath);
        navigate(deepLink.currentPath, { replace: true });
        return; // stop further checks
      }
    }

    setCheckedDeepLink(true); // allow normal redirect logic to proceed
  }, []);

  // Wait until deepLink logic is checked before deciding what to render
  if (!checkedDeepLink) return null;
  if (GetScope() == undefined) { return <Navigate to={`/customers`} /> }
  if (GetScope() !== undefined) { return <Navigate to={`/customers/${GetScope()}/dashboard`} /> }
};

export default Home;